import { handleResponse, handleError, authHeader } from "./apiUtils";
import axios from "axios";
import { API_ROOT } from "./api-config";

const base = API_ROOT + "orgchart/";

export function getOrgChart(groupBy) {
  return axios({
    method: "GET",
    url: base + "GetOrgChart",
    headers: authHeader(),
    params: { groupBy: groupBy },
  })
    .then(handleResponse)
    .catch(handleError);
}
